export default __webpack_public_path__ + "static/media/DennisChen.fa96e39c.png";